import React from 'react'
import { Link } from 'react-router-dom'
import { ToolkitPageLayout } from '../../../components'

// TODO: Define a proper type for breadcrumbs if not already available globally
interface Breadcrumb {
  label: string
  path: string
}

// TODO: Consider creating a reusable PdfLink or ResourceLink component
// interface ResourceLinkProps {
//   href: string;
//   title: string;
//   isDownload?: boolean;
//   description?: string;
// }

export const ClinicsPatientEducationPage: React.FC = () => {
  const pageTitle = 'Patient Education Materials'
  const breadcrumbs: Breadcrumb[] = [
    { label: 'Toolkit', path: '/toolkit' },
    { label: 'Clinics', path: '/toolkit/clinics' },
    { label: pageTitle, path: '/toolkit/clinics/patient-education' }
  ]

  // URLs from toolkit_content.json - to be replaced with actual hosted file URLs or asset imports
  const resources = {
    ashGuidelines: [
      {
        href: 'https://www.dropbox.com/scl/fi/03vq547riqc3me4fqi62o/ASH_SCD-Guideline-Methodology-Infographic_2019.pdf?rlkey=yh8ize55kjka3idbudrl3s2bb&dl=0&dl=1',
        title: 'ASH 2020 Sickle Cell Guidelines',
        isDownload: true
      },
      {
        href: 'https://www.hematology.org/education/clinicians/guidelines-and-quality-care/clinical-practice-guidelines/sickle-cell-disease-guidelines',
        title: 'ASH Understanding SCD',
        isExternal: true
      }
    ],
    diseaseModifyingTherapy: [
      {
        href: 'https://exotic-castanets.cloudvent.net/pdfs/SCDFactSheets-Finalflyers-2022.pdf',
        title: 'SCD Fact Sheets',
        isExternal: true
      },
      {
        href: 'https://curesickle.org/system/files/CSC_Conditioning_Patient_Bi_FOLD_FactSheet_042321_Digital_CenterSpread.pdf',
        title: 'Gene Therapy',
        isExternal: true
      },
      {
        href: 'https://www.dropbox.com/scl/fi/dkra49m8di5kamf6fvwzp/Hydroxyurea-Booklet.pdf?rlkey=ij91ed6i0o5wbkpjz32f6mg09&dl=0&dl=1',
        title: 'ASH Hydroxyurea Patient Education Booklet',
        isDownload: true
      },
      {
        href: 'https://www.dropbox.com/scl/fi/tzctqc5m03tt0q0es41eu/Simple-Transfusion-and-Partial-Manual-Exchange-Patient-Education-2.pdf?rlkey=qnx71fk018fxls0mzd1uc7gi2&dl=0&dl=1',
        title:
          'Simple Transfusion and Partial Manual Exchange Patient Education',
        isDownload: true
      }
    ],
    painManagement: [
      {
        href: 'https://www.dropbox.com/scl/fi/8n680nplj1egy49dy5nvv/American-J-Hematol-2022-David-Converting-adults-with-sickle-cell-disease-from-full-agonist-opioids-to-buprenorphine.pdf?rlkey=9eiy77wkmx5oxs2z3i9xqi7du&dl=0&dl=1',
        title: 'Safety of Buprenorphine and Sickle Cell Disease',
        isDownload: true
      },
      {
        href: 'https://www.dropbox.com/scl/fi/272pqf8oha422v58cc75y/1-s2.0-S1526590023005424-main.pdf?rlkey=9jm7cr80s1mhfyxu82ay6w80q&dl=0&dl=1',
        title: 'Patient Experiences with Buprenorphine',
        isDownload: true
      }
    ],
    sickleCellCenterResources: [
      {
        href: 'https://www.dropbox.com/scl/fi/r4ge158ewceq4rqs84gh1/SC-Brochure-2.pdf?rlkey=xcyu0x6jrnxk6sxbik2nnr95k&dl=0&dl=1',
        title: 'Sickle Cell Infusion Center Brochure',
        isDownload: true
      }
    ],
    pregnancyFertility: [
      {
        href: 'https://www.dropbox.com/scl/fi/hhjdm957gc9xrks56klme/Preconception_SickleCell_2023-508.pdf?rlkey=dajbmwzl5p753z9oa5lc2iypn&dl=0&dl=1',
        title: 'Preconception Sickle Cell',
        isDownload: true
      },
      {
        href: 'https://www.dropbox.com/scl/fi/nui8u8t6i69l3cfem1ppi/Prenatal_SickleCell_2023-508.pdf?rlkey=4qh1v81b0wa37kpmcsn2vcmlo&dl=0&dl=1',
        title: 'Prenatal Sickle Cell',
        isDownload: true
      },
      {
        href: 'https://www.dropbox.com/scl/fi/q73hty0mgf5z6jwqb3kgz/factsheet_scicklecell_status.pdf?rlkey=5zerr4yxii9y9qgaqp8nhr4wm&dl=0&dl=1',
        title: 'Sickle Cell Status Fact Sheet',
        isDownload: true
      },
      {
        href: 'https://www.dropbox.com/scl/fi/kve26vwgdegznyx345e3h/Family-Planning-Options-for-Couples-with-SCT-or-SCD-12.9.21.2-1.pdf?rlkey=dy1o9mzft82y0ts00x6ep6nua&dl=0&dl=1',
        title: 'Family Planning Options for Couples with SCT or SCD',
        isDownload: true
      },
      {
        href: 'https://www.dropbox.com/scl/fi/n45b5emd5uirgd72dkhmh/Postpartum_SickleCell-2023-508-1.pdf?rlkey=0gw5ptws2e6hxuq0br6ov28i0&dl=0&dl=1',
        title: 'Postpartum Care Sickle Cell',
        isDownload: true
      }
    ]
  }

  // TODO: Refactor to use a common ResourceCard or LinkCard component
  const renderResourceLink = (resource: {
    href: string
    title: string
    isDownload?: boolean
    isExternal?: boolean
  }) => (
    <div
      key={resource.title}
      className="mb-8 p-4 border border-gray-300 rounded-lg shadow-lg bg-white transition-all hover:shadow-xl"
    >
      {resource.isDownload && (
        <div className="mb-4">
          <object
            data={resource.href}
            type="application/pdf"
            width="100%"
            height="500px" // Standard height for embedded PDF
            aria-label={`Embedded PDF: ${resource.title}`}
            className="rounded-md border border-gray-200"
          >
            <p className="text-sm text-red-600 p-4 bg-red-50 rounded-md">
              It appears your browser does not support embedded PDFs. You can{' '}
              <a href={resource.href} className="underline font-medium">
                download the PDF
              </a>{' '}
              to view it.
            </p>
          </object>
        </div>
      )}
      <a
        href={resource.href}
        target="_blank"
        rel="noopener noreferrer"
        // For downloads, the <object> above handles viewing, this link is for explicit download
        // For external links, this is the primary way to access the resource
        download={resource.isDownload}
        className={`inline-flex items-center px-4 py-2 border border-transparent text-base font-medium rounded-md shadow-sm text-white focus:outline-none focus:ring-2 focus:ring-offset-2 transition-colors duration-200 ${
          resource.isDownload
            ? 'bg-[#713d43] hover:bg-[#5a3135] focus:ring-[#713d43]' // Download button style
            : 'bg-[#A6410A] hover:bg-[#894d35] focus:ring-[#A6410A]' // External link style
        }`}
      >
        {resource.isDownload && (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-5 w-5 mr-2 flex-shrink-0"
            viewBox="0 0 20 20"
            fill="currentColor"
          >
            <path
              fillRule="evenodd"
              d="M6 2a2 2 0 00-2 2v12a2 2 0 002 2h8a2 2 0 002-2V7.414A2 2 0 0015.414 6L12 2.586A2 2 0 0010.586 2H6zm5 6a1 1 0 10-2 0v3.586l-1.293-1.293a1 1 0 10-1.414 1.414l3 3a1 1 0 001.414 0l3-3a1 1 0 00-1.414-1.414L11 11.586V8z"
              clipRule="evenodd"
            />
          </svg>
        )}
        {resource.isExternal && (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-5 w-5 mr-2 flex-shrink-0"
            viewBox="0 0 20 20"
            fill="currentColor"
          >
            <path d="M11 3a1 1 0 100 2h2.586l-6.293 6.293a1 1 0 101.414 1.414L15 6.414V9a1 1 0 102 0V4a1 1 0 00-1-1h-5z" />
            <path d="M5 5a2 2 0 00-2 2v8a2 2 0 002 2h8a2 2 0 002-2v-3a1 1 0 10-2 0v3H5V7h3a1 1 0 000-2H5z" />
          </svg>
        )}
        {resource.isDownload ? `Download: ${resource.title}` : resource.title}
      </a>
      {resource.isDownload && (
        <p className="text-xs text-gray-600 mt-2">
          (TODO: Host PDF and ensure the link above points to the correct hosted
          file. The embedded viewer uses the same link.)
        </p>
      )}
    </div>
  )

  return (
    <ToolkitPageLayout title={pageTitle} breadcrumbs={breadcrumbs}>
      <div className="prose max-w-none text-[#3C2416]">
        <p className="text-lg italic mb-8">
          The goal is to provide patients and families with information on
          sickle cell disease management and ways to improve your health.
        </p>

        <hr className="my-10" />

        {/* ASH Sickle Cell Guidelines Section */}
        <section className="mb-12">
          <h3 className="text-2xl font-semibold text-[#142841] mt-8 mb-6 border-b-2 border-[#A0B2B4] pb-2">
            ASH Sickle Cell Guidelines
          </h3>
          {resources.ashGuidelines.map(renderResourceLink)}
        </section>

        {/* Disease Modifying Therapy Section */}
        <section className="mb-12">
          <h3 className="text-2xl font-semibold text-[#142841] mt-8 mb-6 border-b-2 border-[#A0B2B4] pb-2">
            Disease Modifying Therapy
          </h3>
          {resources.diseaseModifyingTherapy.map(renderResourceLink)}
        </section>

        {/* Pain Management Section */}
        <section className="mb-12">
          <h3 className="text-2xl font-semibold text-[#142841] mt-8 mb-6 border-b-2 border-[#A0B2B4] pb-2">
            Pain Management
          </h3>
          {resources.painManagement.map(renderResourceLink)}
        </section>

        {/* Sickle Cell Center Education and Resources Section */}
        <section className="mb-12">
          <h3 className="text-2xl font-semibold text-[#142841] mt-8 mb-6 border-b-2 border-[#A0B2B4] pb-2">
            Sickle Cell Center Education and Resources
          </h3>
          {resources.sickleCellCenterResources.map(renderResourceLink)}
        </section>

        {/* Pregnancy, Fertility and Pre-Conception Planning Section */}
        <section className="mb-12">
          <h3 className="text-2xl font-semibold text-[#142841] mt-8 mb-6 border-b-2 border-[#A0B2B4] pb-2">
            Pregnancy, Fertility and Pre-Conception Planning
          </h3>
          {resources.pregnancyFertility.map(renderResourceLink)}
        </section>

        <hr className="my-12" />

        {/* All Done Button */}
        <div className="mt-12 mb-8 text-center">
          <Link
            to="/toolkit/clinics" // Link to the main clinics page
            className="bg-[#A6410A] hover:bg-[#894d35] text-white rounded-md px-6 py-3 text-lg font-medium transition-colors duration-200 shadow-md hover:shadow-lg"
          >
            All done? Click here to return to the Clinics screen
          </Link>
        </div>
      </div>
    </ToolkitPageLayout>
  )
}
